import Vue from 'vue'
import App from './App'
import router from './router'
import { get, post } from './apis/axios'
import * as filter from './apis/filter'
import directive from './apis/directive'

import ElementUI from 'element-ui'

//第三方样式
import 'element-ui/lib/theme-chalk/index.css';
import './assets/element/element.css'
import './assets/css/reset.css'
import './assets/css/common.css'
import './assets/css/style.css'
import './assets/css/iconfont.css'

Vue.prototype.post = post;
Vue.prototype.get = get;

Vue.use(ElementUI)
Vue.config.productionTip = false

//子父传值
let onEmit = new Vue()
Vue.prototype.onEmit = onEmit

//URL
Vue.prototype.token = localStorage.getItem('token')

//全局过滤器
Object.keys(filter).forEach(key => { 
  Vue.filter(key, filter[key]) 
})

//全局指令
Object.keys(directive).forEach(key =>{
  Vue.directive(key, directive[key])
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js